import { FlexColumn, FlexRow, MaterialIcon } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { StyledDivider } from 'baseui/divider';
import { useStyles } from '../../hooks/useStyles';
import StyledTooltip from '../ui/StyledTooltip';
import StyledModal from './StyledModal';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  imgUrl: string;
  onDownload?: () => void;
};

export function ImagePreview({ isOpen, onClose, imgUrl, onDownload }: Readonly<Props>) {
  const { css, theme } = useStyles();

  const onCloseModal = () => {
    onClose();
  };

  return (
    <StyledModal
      isOpen={isOpen}
      closeable
      onClose={onCloseModal}
      size="auto"
      content={
        <FlexColumn
          classNames={css({
            justifyContent: 'space-between',
            overflow: 'hidden',
            width: '525px',
            height: '525px',
            gap: theme.sizing.scale200,
          })}
        >
          <FlexColumn
            classNames={css({
              justifyContent: 'center',
              alignItems: 'center',
              flex: 1,
            })}
          >
            <img
              src={imgUrl}
              alt=""
              className={css({
                maxWidth: '450px',
                maxHeight: '450px',
                objectFit: 'cover',
              })}
            />
          </FlexColumn>
          {onDownload && (
            <>
              <StyledDivider
                $size="cell"
                style={{ marginTop: 0, marginBottom: 0, width: '100%' }}
              />
              <FlexRow>
                <StyledTooltip
                  content={'Descargar'}
                  showArrow={false}
                >
                  <Button
                    size="mini"
                    shape="square"
                    onClick={onDownload}
                    kind="tertiary"
                  >
                    <MaterialIcon name="download" />
                  </Button>
                </StyledTooltip>
              </FlexRow>
            </>
          )}
        </FlexColumn>
      }
    />
  );
}
